import { cloneDeep } from "lodash";
import { userUtil } from "../../utils";

const PUSH_USERS = "app/users/PUSH_USERS";
const SET_USER_TO_EDIT = "app/users/SET_USER_TO_EDIT";
const RESET_USERS = "app/users/RESET_USERS";
const SET_LOADING = "app/users/SET_LOADING";
const SET_REFRESH = "app/users/SET_REFRESH";
const SET_ERROR = "app/users/SET_ERROR";
const SET_USER_FILTERS = "app/users/SET_USER_FILTERS";

const initialState = {
  users: null,
  userFilters: {
    status: null,
    apps: null,
    groups: null,
    markets: null,
    type: null
  },
  userToEdit: null,
  loading: false,
  refresh: false,
  error: null
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case PUSH_USERS: {
      const clonedState = cloneDeep(state);

      const newUsers = userUtil.formatUsers(action.payload);

      return {
        ...clonedState,
        users: clonedState.users ? [...clonedState.users, ...newUsers] : newUsers
      };
    }

    case RESET_USERS: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        users: null
      };
    }

    case SET_REFRESH: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        refresh: action.payload
      };
    }

    case SET_LOADING: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        loading: action.payload
      };
    }

    case SET_ERROR: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        error: action.payload
      };
    }

    case SET_USER_TO_EDIT: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        userToEdit: action.payload
      };
    }

    case SET_USER_FILTERS: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        userFilters: { ...clonedState.userFilters, ...action.payload }
      };
    }

    default: {
      return state;
    }
  }
}

export const pushUsers = (users) => ({ type: PUSH_USERS, payload: users });

export const setUserToEdit = (user) => ({ type: SET_USER_TO_EDIT, payload: user });

export const resetUsers = () => ({ type: RESET_USERS });

export const setLoading = (loading) => ({ type: SET_LOADING, payload: loading });

export const setRefresh = (refresh) => ({ type: SET_REFRESH, payload: refresh });

export const setError = (error) => ({ type: SET_ERROR, payload: error });

export const setFilters = (filters) => ({ type: SET_USER_FILTERS, payload: filters });
